import { useState } from 'react';
import { Menu } from '@mui/material';
import { cloneElement } from 'react';

function Dropdown({ anchor, children }){
  const [ anchorEl, setAnchorEl ] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return(
    <>
      {cloneElement(anchor, {
        onClick: handleClick
      })}
      <Menu
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {children}
      </Menu>
    </>
  )
} export default Dropdown;